module.exports = __webpack_public_path__ + "media/images/default/pages/homepage/depth_views/1-627c51f850ab0d48b5a369f4ecbe2023.jpg";